import styled from 'styled-components';
import { AppBar, Box, IconButton, List, ListItemText } from '@mui/material';

export const StyledAppBar = styled(AppBar)`
  background-color: #5e81f4;
  margin-bottom: 25px;
`;
export const StyledHeaderBox = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin-left: 20px;

  @media (max-width: 600px) {
    margin-left: 10px;
    flex-direction: row;
  }
`;
export const StyledIconButton = styled(IconButton)`
  margin-left: auto;
`;

export const StyledList = styled(List)`
  width: 250;
`;
export const StyledLinksBox = styled(Box)`
  display: flex;
  align-items: center;

  @media (max-width: 600px) {
    display: none; /* Verstecke Links auf kleinen Geräten */
  }
`;

export const StyledLink = styled.a`
  text-decoration: none;
  color: white;
  font-weight: bold;
  margin-left: 20px;

  &:hover {
    text-decoration: underline;
  }
`;
export const StyledListItemText = styled(ListItemText)`
  color: white;
`;
